import { ENDPOINT_SUBSCRIPTIONS } from '../config'
import type { SubscriptionDocument } from '@/lib/types/subscription'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Reactivate a subscription that is scheduled to cancel at period end —
 * clears the pending cancellation so it keeps renewing. No-op-safe on the
 * backend; throws (with a structured error) if the subscription is already
 * fully canceled and can't be reinstated.
 */
export async function reactivateSubscription(): Promise<SubscriptionDocument> {
  const response = await AuthAxios.post<SubscriptionDocument>(
    `${ENDPOINT_SUBSCRIPTIONS}/reactivate`,
    {},
  )
  return response.data
}
